export const commonTranslations = {
  pt: {
    // Footer
    'footer.tagline': 'Seu cliente de volta, sempre.',
    'footer.copyright': 'Loyol',

    // Shared nav/CTA
    'nav.contact': 'CONTATO',
    'nav.learnmore': 'saiba mais',
    'nav.pricing': 'PREÇO',
    'nav.howitworks': 'COMO FUNCIONA',
    'cta.letstalk': 'vamos conversar',

    // Contact form
    'contact.eyebrow': 'CONTE SOBRE SEU NEGÓCIO',
    'contact.title': 'Vamos encontrar onde o Seller pode trabalhar por você.',
    'contact.description': 'Envie um contexto curto. Nós analisamos e respondemos por email.',
    'contact.name': 'Nome',
    'contact.namePlaceholder': 'Como podemos chamar você?',
    'contact.email': 'Email',
    'contact.emailPlaceholder': 'voce@empresa.com',
    'contact.company': 'Empresa',
    'contact.companyPlaceholder': 'Nome da empresa',
    'contact.message': 'O que você vende ou quer automatizar?',
    'contact.messagePlaceholder': 'Conte brevemente como sua operação funciona hoje.',
    'contact.submit': 'ENVIAR PARA ANÁLISE',
    'contact.sending': 'ENVIANDO…',
    'contact.privacy': 'Usaremos estes dados somente para analisar e responder ao seu contato.',
    'contact.success': 'Recebemos seu contato. Vamos analisar o contexto e responder por email.',
    'contact.error': 'Não foi possível enviar agora. Confira sua conexão e tente novamente.',
    'contact.footerNote': 'Envie seu contexto pelo formulário. Respondemos por email.',
  },
  en: {
    'footer.tagline': 'Bringing your customers back. Always.',
    'footer.copyright': 'Loyol',

    'nav.contact': 'CONTACT',
    'nav.learnmore': 'learn more',
    'nav.pricing': 'PRICING',
    'nav.howitworks': 'HOW IT WORKS',
    'cta.letstalk': "get in touch",

    'contact.eyebrow': 'TELL US ABOUT YOUR BUSINESS',
    'contact.title': 'Let’s find where Seller can work for you.',
    'contact.description': 'Send us a short overview. We will review it and reply by email.',
    'contact.name': 'Name',
    'contact.namePlaceholder': 'What should we call you?',
    'contact.email': 'Email',
    'contact.emailPlaceholder': 'you@company.com',
    'contact.company': 'Company',
    'contact.companyPlaceholder': 'Company name',
    'contact.message': 'What do you sell or want to automate?',
    'contact.messagePlaceholder': 'Briefly tell us how your operation works today.',
    'contact.submit': 'SEND FOR REVIEW',
    'contact.sending': 'SENDING…',
    'contact.privacy': 'We will use this information only to review and reply to your enquiry.',
    'contact.success': 'We have received your enquiry. We will review it and reply by email.',
    'contact.error': 'We could not send this right now. Check your connection and try again.',
    'contact.footerNote': 'Send your context through the form. We reply by email.',
  },
  it: {
    'footer.tagline': 'I tuoi clienti tornano. Sempre.',
    'footer.copyright': 'Loyol',

    'nav.contact': 'CONTATTO',
    'nav.learnmore': 'scopri di più',
    'nav.pricing': 'PREZZI',
    'nav.howitworks': 'COME FUNZIONA',
    'cta.letstalk': 'contattaci',

    'contact.eyebrow': 'RACCONTACI LA TUA ATTIVITÀ',
    'contact.title': 'Scopriamo dove Seller può lavorare per te.',
    'contact.description': 'Inviaci un breve contesto. Lo analizzeremo e risponderemo via email.',
    'contact.name': 'Nome',
    'contact.namePlaceholder': 'Come possiamo chiamarti?',
    'contact.email': 'Email',
    'contact.emailPlaceholder': 'tu@azienda.com',
    'contact.company': 'Azienda',
    'contact.companyPlaceholder': 'Nome dell’azienda',
    'contact.message': 'Cosa vendi o vuoi automatizzare?',
    'contact.messagePlaceholder': 'Raccontaci brevemente come funziona oggi la tua operazione.',
    'contact.submit': 'INVIA PER L’ANALISI',
    'contact.sending': 'INVIO…',
    'contact.privacy': 'Useremo questi dati solo per analizzare e rispondere al tuo contatto.',
    'contact.success': 'Abbiamo ricevuto il tuo contatto. Lo analizzeremo e risponderemo via email.',
    'contact.error': 'Non è stato possibile inviare ora. Controlla la connessione e riprova.',
    'contact.footerNote': 'Invia il contesto tramite il modulo. Rispondiamo via email.',
  }
};
